import { Button, ButtonGroup, DialogBody, HStack, Stack, Text } from "@chakra-ui/react"
import { UI } from "components"
import useUser from "hooks/useUser"
import { useNavigate } from "react-router"

export default function Indication(props){

    const navigate = useNavigate()
    const user = useUser()
    const indication_url = `https://bonifi.ca/${user.data?.username}`

    const handleShare = async () => {
        await navigator.share({
            title: `Convite de ${user.data?.name}`,
            text: `Olá! Este é um convite para participar da minha rede na Bonífica.\n\n Para participar, basta clicar no link: ${indication_url}`,
            url: indication_url
        })
    }

    return(
    <UI.Dialog size="xs" title="Cadastrar downline" {...props}>
        <DialogBody>
            <Stack gap={4}>

                <Text>Cadastre pessoas abaixo de você e aumente cada vez mais a sua rede.</Text>

                <UI.Clipboard label="Link de indicação:" size="sm" value={indication_url} colorPalette="orange" inputProps={{ fontWeight: 'bold', color: 'orange.fg' }} />

                <ButtonGroup variant="ghost" size="xs">
                    <Button colorPalette="green" onClick={handleShare}><UI.Icon name="share" /> Compartilhar</Button>
                    <Button onClick={() => navigate('/perfil')}><UI.Icon name="link" /> Alterar link</Button>
                </ButtonGroup>
            </Stack>
        </DialogBody>
    </UI.Dialog>
    )
}